import { api } from '@/lib/api'

export interface StartImpersonationResponse {
  sessionId: string
  targetApp: 'student' | 'counselor' | 'admin'
  targetName: string | null
  redirectUrl: string
  codeExpiresInSeconds: number
}

const APP_LABELS: Record<StartImpersonationResponse['targetApp'], string> = {
  student: 'student app',
  counselor: 'counselor app',
  admin: 'admin portal',
}

export const describeTargetApp = (app: StartImpersonationResponse['targetApp']) => APP_LABELS[app]

/**
 * Ask the backend for a one-time link and open it in a new tab.
 *
 * The tab is opened *synchronously* on click, then pointed at the link once the
 * request returns — opening it after an `await` is treated as an unrequested
 * popup by Safari and some Chrome configurations.
 */
export async function startImpersonation(targetUserId: string): Promise<StartImpersonationResponse> {
  const tab = window.open('', '_blank')
  try {
    const result = await api.post<StartImpersonationResponse>('/impersonation/start', { targetUserId })
    if (tab) {
      tab.location.href = result.redirectUrl
    } else {
      // Popup blocked entirely — fall back to this tab rather than failing silently.
      window.location.href = result.redirectUrl
    }
    return result
  } catch (error) {
    tab?.close()
    throw error
  }
}
